const autoNgTemplateLoaderTemplate1 = require('./box-selector-item.html');

import angular from 'angular';

import './box-selector-item.css';

import controller from './box-selector-item.controller';

angular.module('portainer.app').component('boxSelectorItem', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller,
  require: {
    formCtrl: '^^form',
  },
  bindings: {
    radioName: '@',
    isChecked: '<',
    option: '<',
    onChange: '<',
    disabled: '<',
    tooltip: '<',
  },
});
